import { HelmetProvider } from 'react-helmet-async';
import { VHSProvider } from '@wistia/vhs';
import { UIProvider } from '@wistia/ui';
import { WistiaProvider } from '@wistia/react-embeds';
import { StyledComponentsCompatibilityProvider } from '~/singlePageApp/providers/StyledComponentsCompatibilityProvider';
import { wistiaTheme } from '~/singlePageApp/wistiaTheme';
import { WistiaApolloProvider } from '../../providers/WistiaApolloProvider';
import { BottlerApolloProvider } from '../../bottler';
import { GlobalStyle } from '../GlobalStyle';
import { fastBaseHostname } from '~/constantDefinitions';
import { FeatureFlagProvider } from '~/singlePageApp/providers/FeatureFlagProvider';
import { OnboardingProvider } from '~/onboarding/hooks/useOnboardingContext/OnboardingProvider';
import { TooltipProvider } from '~/components/Tooltip/BasicTooltip';

export const AnonymousAppProviders = ({ children }) => {
  return (
    <WistiaApolloProvider schema="AnonymousSchema">
      <StyledComponentsCompatibilityProvider>
        <FeatureFlagProvider>
          <BottlerApolloProvider>
            <WistiaProvider origin={`https://${fastBaseHostname}`}>
              <VHSProvider theme={wistiaTheme}>
                <UIProvider>
                  <TooltipProvider>
                    <OnboardingProvider>
                      <GlobalStyle />
                      <HelmetProvider>{children}</HelmetProvider>
                    </OnboardingProvider>
                  </TooltipProvider>
                </UIProvider>
              </VHSProvider>
            </WistiaProvider>
          </BottlerApolloProvider>
        </FeatureFlagProvider>
      </StyledComponentsCompatibilityProvider>
    </WistiaApolloProvider>
  );
};
